import React from "react";
import { useState, useEffect } from "react";
import { Input, TextArea } from "@progress/kendo-react-inputs";

import { partnerService } from '../../services/api/partner.service';


export const MyAccount = (props) => {
	const initalState = {
		id:0, nume: '', prenume: '', cnp: '', telefon: '', email: '', comentarii: ''
	}
	const [userInfo, setUserInfo] = useState(initalState);
	const partener = sessionStorage.getItem('idPartener');
	const idUtilizator = sessionStorage.getItem('idUtilizator');
	

	useEffect(() => {
		partnerService.getUserInfo({ username: idUtilizator, partener :partener })
			.then((response) => {
				if (response) {
					setUserInfo(response);
				}
				else {
					setUserInfo(initalState);
				}
			})
	}, [idUtilizator]);

	const handleChange = (event) => {
		const { name, value } = event.target;
        setUserInfo({ ...userInfo, [name]: value });
	}

	const handleSave = (event) => {
		event.preventDefault();
		partnerService.updateUserInfo(userInfo)
			.then((response) => {
				if (response) {
					console.log('saveUserInfo', response);
				}
				else {
					console.log('eroare la saveUserInfo');
				}
			});
	}

    return (
        <>
			<h2>Contul meu</h2>
			<div className="formular clearfix">
				<fieldset>
					<div className="fl pr40">
						<p className="clearfix pb10">
							<label className="pb5">Nume:</label>
							<Input className="w200" name="nume" value={userInfo.nume} onChange={ handleChange } />
						</p>
						<p className="clearfix pb10">
							<label className="pb5">Prenume:</label>
							<Input className="w200" name="prenume" value={userInfo.prenume} onChange={handleChange} />
						</p>
						<p className="clearfix pb10">
							<label className="pb5">CNP:</label>
							<Input className="w200" name="cnp" maxLength="13" value={userInfo.cnp} onChange={handleChange} />
						</p>
						<p className="clearfix pb10">
							<label className="pb5">Telefon:</label>
							<Input className="w200" name="telefon" placeholder="____-___-___" maxLength="12" value={userInfo.telefon} onChange={handleChange} />
						</p>
						<p className="clearfix pb15">
							<label className="pb5">Email:</label>
							<Input className="w200" name="email" value={userInfo.email} onChange={handleChange} />
						</p>
						<p className="clearfix">
							<button className="w100 btn" data-name="save" onClick={ handleSave}>Salveaza</button>
						</p>
					</div>


					<div className="fl mt20">
						<p className="clearfix">
							<label className="pb5">Comentarii</label>
							<TextArea className="w400 comments"
								name="comentarii"
								value={userInfo.comentarii ?? ""}
								onChange={handleChange}
							/>
						</p>
					</div>


				</fieldset>
			</div>
        </>
    );
};
